import styled, { css, keyframes } from 'styled-components';

import { MobileModalProps } from './MobileModal';

import { IconButton } from '@speeki/icons';

import { CONTAINER_SIDE_PADDINGS } from '@shared/constants';

const ModalFadeIn = keyframes`
    from{
        opacity: 0
    }
    to{
        opacity: 1
    }
`;

export const MobileModalWrapper = styled.div<
    Pick<MobileModalProps, 'topPadding'>
>(
    ({ theme: { palette }, topPadding }) => css`
        animation: ${ModalFadeIn} 0.3s forwards;
        background-color: ${palette.neutral.white};
        display: grid;
        grid-template-rows: 1fr auto;
        height: 100%;
        left: 0;
        outline: 0;
        overflow-x: hidden;
        overflow-y: auto;
        padding-top: ${topPadding}px;
        position: fixed;
        top: 0;
        width: 100%;
        will-change: opacity;
        z-index: 999;
    `,
);

export const MobileModalCloseButton = styled(IconButton)<{ top: number }>(
    ({ top }) => css`
        position: absolute;
        right: ${CONTAINER_SIDE_PADDINGS.xs}px;
        top: ${top}px;
        z-index: 9999;
    `,
);

export const MobileModalContainer = styled.div`
    padding: 0 ${CONTAINER_SIDE_PADDINGS.xs}px 0;
`;
